/**
 * ChatFAB Component (Floating Action Button)
 * Fixed button at bottom-right to open/close chat widget
 * Theme-aware with Tailwind dark: prefix classes
 */

import { ChatFABProps } from '../../types/liveChat';
import { cn } from '../../utils/cn';
import { MessageCircle, X } from 'lucide-react';

export const ChatFAB: React.FC<Omit<ChatFABProps, 'theme'>> = ({
  isOpen,
  onClick
}) => {
  return (
    <button
      onClick={onClick}
      className={cn(
        'fixed bottom-6 right-6 z-40 w-14 h-14 rounded-full shadow-lg',
        'flex items-center justify-center transition-all duration-300',
        'hover:scale-110 focus-visible:outline-2 focus-visible:outline-offset-2',
        'focus-visible:outline-primary-500',
        isOpen
          ? 'bg-primary-600 dark:bg-primary-700 shadow-neutral-900/40 dark:shadow-neutral-900/60'
          : 'bg-primary-600 hover:bg-primary-700 dark:bg-primary-600 dark:hover:bg-primary-500 shadow-neutral-200/50 dark:shadow-neutral-900/40'
      )}
      aria-label={isOpen ? 'Close live chat' : 'Open live chat'}
      title="Live Chat"
    >
      {isOpen ? (
        <X className="w-6 h-6 text-white" />
      ) : (
        <MessageCircle className="w-6 h-6 text-white" />
      )}

      {/* Focus ring */}
      <div className="absolute inset-0 rounded-full border-2 border-transparent focus-visible:border-primary-300 opacity-0 group-focus-visible:opacity-100 pointer-events-none" />
    </button>
  );
};